export const ApiDef_Value = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map